import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'ariaLabel',
  standalone: false
})
export class AriaLabelPipe implements PipeTransform {
  transform(value: string, skip: boolean = false): string {
    const prefix = 'aria.';

    if (typeof value !== 'string' || !value) {
      return '';
    }

    if (skip || value.startsWith(prefix)) {
      return value;
    }

    if (value.startsWith('lbl.')) {
      value = value.slice('lbl.'.length);
    }

    return prefix + value;
  }
}
